import PasswordSettingWidget from './PasswordSettingWidget';
export default PasswordSettingWidget;
